import { useState } from 'react';
import { Button } from '@icebreaker/ui';
import { useTranslation } from '@/shared/i18n/i18n-provider';
import { SessionsDialog } from './sessions-dialog';

/**
 * "OTURUMLAR" — panelin hesap menüsündeki giriş noktası.
 *
 * ROTA DEĞİL KATMAN, şifre değiştirmeyle AYNI gerekçeyle (`change-password-
 * button.tsx`): oturum listesi personelin KENDİ hesabına dair bir eylemdir,
 * yönetim ekranı değil. Yan gezinme `SCREEN_ROUTES` envanterinin ve yetki
 * kapısının alanıdır; `panel/auth` uçları ise her personelin taban yetkisiyle
 * koşar ve `SELF_OR_PUBLIC_ENDPOINTS` içinde beyanlı muafiyettedir — yani
 * karar "yetkin var mı" değil "oturumun var mı"dır ve onu `StaffGate` verir.
 *
 * Katman durumu burada yaşar; veri katman AÇILINCA saga üzerinden istenir.
 */
export function SessionsButton() {
  const t = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button variant="ghost" size="sm" onClick={() => setOpen(true)}>
        {t.t('admin.panel.sessions.action')}
      </Button>
      <SessionsDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
}
